module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Menu', {
    attrs: {
      "mode": "horizontal",
      "theme": "dark"
    }
  }, [_c('div', {
    staticClass: "layout-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.vendorInfo.logo_url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layout-nav"
  }), _vm._v(" "), _c('div', {
    staticClass: "layout-user"
  }, [_c('MenuItem', {
    attrs: {
      "name": "user-notification",
      "to": "/message"
    }
  }, [_c('Icon', {
    staticStyle: {
      "font-size": "24px",
      "color": "white",
      "float": "left",
      "line-height": "60px",
      "height": "60px"
    },
    attrs: {
      "type": "ios-notifications"
    }
  })], 1), _vm._v(" "), _c('Submenu', {
    attrs: {
      "name": "30"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "person"
    }
  }), _vm._v("\n          " + _vm._s(_vm.vendorInfo.name) + "\n        ")], 1), _vm._v(" "), _c('Menu-item', {
    attrs: {
      "name": "30-1"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openUpdatePwdModal.apply(null, arguments)
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('Menu-item', {
    attrs: {
      "name": "30-2"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onLogout.apply(null, arguments)
      }
    }
  }, [_vm._v("登出")])], 2)], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "修改登录密码",
      "mask-closable": false,
      "loading": _vm.loading
    },
    on: {
      "on-ok": _vm.ok,
      "on-cancel": function($event) {
        _vm.showUpdatePwdModal = false
      }
    },
    model: {
      value: (_vm.showUpdatePwdModal),
      callback: function($$v) {
        _vm.showUpdatePwdModal = $$v
      },
      expression: "showUpdatePwdModal"
    }
  }, [_c('Form', {
    ref: "updateForm",
    attrs: {
      "model": _vm.updateForm,
      "label-width": 100,
      "rules": _vm.formRules
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老密码",
      "prop": "oldPwd"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入旧密码"
    },
    model: {
      value: (_vm.updateForm.oldPwd),
      callback: function($$v) {
        _vm.$set(_vm.updateForm, "oldPwd", $$v)
      },
      expression: "updateForm.oldPwd"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "新密码",
      "prop": "newPwd1"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入新密码，至少8位"
    },
    model: {
      value: (_vm.updateForm.newPwd1),
      callback: function($$v) {
        _vm.$set(_vm.updateForm, "newPwd1", $$v)
      },
      expression: "updateForm.newPwd1"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "新密码",
      "prop": "newPwd2"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "请再次输入新密码"
    },
    model: {
      value: (_vm.updateForm.newPwd2),
      callback: function($$v) {
        _vm.$set(_vm.updateForm, "newPwd2", $$v)
      },
      expression: "updateForm.newPwd2"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66fc5b4d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 95
// module chunks = 14